<template>
  <div>
    <HeaderCreditor header="ลูกหนี้" :img_header="header_image" link_back="creditor/all"/>
    <MenuDebtor/>
    <Report_debtor/>
  </div>
</template>

<script>
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor";
import HeaderImage from "@/assets/segment_creditor.png";
import MenuDebtor from "@/components/admin/creditor/menucreditor/MenuDebtor";
import Report_debtor from "@/components/admin/creditor/Report_debtor";
export default {
  name: "ReportDebtor",
  components: {
    Report_debtor,
    MenuDebtor,
    HeaderCreditor
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
